import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const [index, setIndex] = useState(1);
    const toRotate = [ "Software Engineer" ];
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);

        return () => { clearInterval(ticker) };
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setIndex(prevIndex => prevIndex - 1);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setIndex(1);
            setDelta(500);
        } else {
            setIndex(prevIndex => prevIndex + 1);
        }
    }

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="aligh-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <span className="tagline">Welcome to my Portfolio</span>
                                    <h1>{`Hi! I'm Taha GHADI,`} <span className="txt-rotate" dataPeriod="1000"
                                                                     data-rotate='["Software Engineer"]'><span
                                        className="wrap">{text}</span></span></h1>
                                    <p>
                                        I am a passionate and detail-oriented software developer with a knack for
                                        creating robust and user-friendly web applications. With expertise in full-stack
                                        development, I specialize in building innovative solutions using modern
                                        technologies like Java, React, Spring Boot, and MySQL. My goal is to
                                        continuously learn, grow, and contribute to impactful projects that solve
                                        real-world problems. Welcome to my portfolio, where creativity meets
                                        functionality!
                                    </p>

                                    <button
                                        onClick={() =>
                                            window.location.href = "mailto:tahaghadi3@gmail.com?subject=Contact%20Taha%20Ghadi&body=Bonjour%20Taha,%0A%0AJe%20souhaite%20entrer%20en%20contact%20avec%20vous."
                                        }
                                    >
                                        Envoyez-moi un message <ArrowRightCircle size={25}/>
                                    </button>

                                </div>}
                        </TrackVisibility>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <TrackVisibility>
                            {({isVisible}) =>
                                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                                    <img src={headerImg} alt="Header Img"/>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}